"use strict";
import React from "react";
import Account from "../../api/account";
import Auth from "../../util/auth";
import { getLoadRelationshipForDocument } from "../helpers/document_load_relationship_helpers";
import {
  DocumentPODDisposition,
  DocumentSignatureDisposition,
  DocumentReferenceMatchDisposition
} from "../data/types/Pb";
import { aiSparkleIcon } from "../ui/icons";
function isEnabled() {
  return Account.showPodDispositionOnIndexing() && Auth.getCurrentUser().managed_indexer;
}
function colorClassForDisposition(disposition) {
  switch (disposition) {
    case DocumentPODDisposition.DocumentPODDispositionKnownNotPOD:
      return "v3__descriptor-tag--color-alert";
    case DocumentPODDisposition.DocumentPODDispositionKnownPOD:
      return "v3__descriptor-tag--color-info";
    default:
      return null;
  }
}
function fallbackText(disposition) {
  return disposition === DocumentPODDisposition.DocumentPODDispositionKnownNotPOD ? "Not a POD" : "POD";
}
function reasonsForDisposition(rel) {
  if (rel.pod_disposition === DocumentPODDisposition.DocumentPODDispositionKnownNotPOD) {
    return negativeReasons(rel);
  } else if (rel.pod_disposition === DocumentPODDisposition.DocumentPODDispositionKnownPOD) {
    return positiveReasons(rel);
  } else {
    return [];
  }
}
function positiveReasons(rel) {
  const reasons = [];
  if (rel.signature_disposition === DocumentSignatureDisposition.DocumentSignatureDispositionKnownSigned)
    reasons.push("Signed");
  if (rel.reference_match_disposition === DocumentReferenceMatchDisposition.DocumentReferenceMatchDispositionKnownMatch)
    reasons.push("Ref #");
  return reasons;
}
function negativeReasons(rel) {
  const reasons = [];
  if (rel.signature_disposition === DocumentSignatureDisposition.DocumentSignatureDispositionKnownNotSigned)
    reasons.push("Not signed");
  if (rel.reference_match_disposition === DocumentReferenceMatchDisposition.DocumentReferenceMatchDispositionKnownNoMatch)
    reasons.push("Missing Ref #");
  return reasons;
}
export const podDispositionLabel = (document, load, documentLoadRelationships) => {
  if (!isEnabled()) return null;
  const rel = getLoadRelationshipForDocument(
    document,
    load,
    documentLoadRelationships
  );
  if (!rel) return null;
  const colorClass = colorClassForDisposition(rel.pod_disposition);
  if (!colorClass) return null;
  const reasons = reasonsForDisposition(rel);
  const text = reasons.length > 0 ? reasons.join(", ") : fallbackText(rel.pod_disposition);
  return /* @__PURE__ */ React.createElement("div", { className: "enable_shared-ui-v3 document-browser__pod-disposition-label" }, /* @__PURE__ */ React.createElement("div", { className: "v3__theme" }, /* @__PURE__ */ React.createElement("span", { className: `v3__descriptor-tag ${colorClass}` }, aiSparkleIcon("currentColor"), "Automation: " + text)));
};
